import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, type DefaultValues, type FieldValues } from 'react-hook-form';
import type { z } from 'zod';

/**
 * react-hook-form with the GOV.UK/ID-SK conventions: validate on submit only, do not move focus to the first
 * invalid field (the error summary receives focus instead).
 */
export function useAppForm<T extends FieldValues>(schema: z.ZodType<T, T>, defaultValues: DefaultValues<T>) {
  return useForm<T>({
    resolver: zodResolver(schema as never) as never,
    defaultValues,
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    shouldFocusError: false,
  });
}
